import React from "react";
import { ShieldCheckIcon, GlobeIcon } from "lucide-react";
import { images } from "../../data/content";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
export function Hero() {
  return <header className="w-full bg-canvas px-4 pb-14 pt-8 sm:pt-12" data-id="element-174" data-mp="huxs5s772px7">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-175" data-mp="hw8wpu8gs1pd">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-176" data-mp="mt94c9kypcil">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-white" data-id="element-177" data-mp="quubdeatewkv">
            <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-178" data-mp="vm2lydnvsnzm" />
          </span>
          <span className="font-serif text-2xl font-black text-ink" data-id="element-179" data-mp="10lyqce0hqhfp">
            Implant Case Decision<sup className="text-xs" data-id="element-180" data-mp="15ks66d392kj1">™</sup>
          </span>
        </div>
        <p className="mt-3 text-sm font-semibold text-brand" data-id="element-181" data-mp="15ifg1cnc93uw">Created by Dr. Michael Carter</p>

        <h1 className="mt-6 font-serif text-[34px] font-black leading-[1.08] text-ink sm:text-5xl md:text-[56px]" data-id="element-182" data-mp="1ahil2x3bja2v">
          Know if you should Accept, Prepare, or Refer an implant case —{" "}
          <em className="text-brand" data-id="element-183" data-mp="4nesoi607dke">before you commit to surgery</em>
        </h1>

        <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-184" data-mp="3vvj4a4oqzip0">
          A practical clinical decision system to evaluate an implant case in{" "}
          <strong className="text-ink" data-id="element-185" data-mp="sek66qoh1trj">15 minutes or less</strong>, identify the critical variables, and reach a structured{" "}
          <strong className="text-accept" data-id="element-186" data-mp="nfr1nnr5xd3i">ACCEPT</strong> / <strong className="text-yellow-600" data-id="element-187" data-mp="io91v30vlik4">PREPARE</strong> /{" "}
          <strong className="text-refer" data-id="element-188" data-mp="imedtfub5abt">REFER</strong> decision. Includes <strong className="text-ink" data-id="element-189" data-mp="em49e7m5yrz2">6 premium volumes</strong> +{" "}
          <strong className="text-ink" data-id="element-190" data-mp="1b5bo4gmiyshj">5 professional bonus tools</strong>.
        </p>

        <img src={images.mockup} alt="Implant Case Decision system: 6 volumes, worksheets and 5 bonus guides" className="mt-8 w-full max-w-2xl" data-id="element-191" data-mp="16ebr7bdeoaf1" />

        <div className="mt-6 w-full max-w-xl" data-id="element-192" data-mp="30o9x4rkiitbv">
          <CtaButton id="hero-cta" label="I want the Implant Case Decision™ system" data-id="element-193" data-mp="35jyxgx4cwe98" />
          <p className="mt-3 text-sm text-muted" data-id="element-194" data-mp="2qwvysn4arzkb">
            Immediate digital access · One-time payment of <strong className="text-ink" data-id="element-195" data-mp="2vufelrgn8ked">$27 USD</strong> · Lifetime access · 7-Day Guarantee
          </p>
        </div>

        <div className="mt-8" data-id="element-196" data-mp="2hums68c5gqc7">
          <Countdown data-id="element-197" data-mp="2hxiq3wnzzf0n" />
        </div>

        <div className="mt-6 w-full max-w-xl" data-id="element-198" data-mp="2mv236t8yllr0">
          <ScarcityBar data-id="element-199" data-mp="2mvu0c8i7frje" />
          <p className="mt-3 flex items-center justify-center gap-1.5 text-sm text-muted" data-id="element-200" data-mp="27x9o227bqzdc">
            <GlobeIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-201" data-mp="27zmel3r5ei20" />
            Currency conversion is handled automatically for your country.
          </p>
        </div>
      </div>
    </header>;
}